<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-100">
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef i18n>Guest</th>
      <td mat-cell *matCellDef="let element">{{ element.title }}</td>
    </ng-container>
    <ng-container matColumnDef="rental">
      <th mat-header-cell *matHeaderCellDef i18n>Rental</th>
      <td mat-cell *matCellDef="let element">
        <app-rental-name [rentalId]="element.rental_id"></app-rental-name>
      </td>
    </ng-container>
    <ng-container matColumnDef="invoiceNum">
      <th mat-header-cell *matHeaderCellDef i18n>Invoice #</th>
      <td mat-cell *matCellDef="let element">{{ element.invoice_num }}</td>
    </ng-container>
    <ng-container matColumnDef="dueDate">
      <th mat-header-cell *matHeaderCellDef i18n>Due Date</th>
      <td mat-cell *matCellDef="let element">{{ element.due_date | epoch }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></tr>
  </table>

  <mat-paginator2
    #paginator
    [length]="$safeNavigationMigration(dataSource?.data?.length)"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</div>
